import React from 'react';
import {
  List,
  Datagrid,
  Create,
  SimpleForm,
  ReferenceInput,
  Filter,
  TextInput,
  AutocompleteInput,
  TextField,
  translate as t,
} from 'admin-on-rest';

import Edit from '../components/Edit';
import EditButton from '../components/button/EditButton';
import DeleteButton from '../components/button/DeleteButton';
import AccountingSheet from '../components/AccountingSheet';
import { isSuperUser } from '../utils/permissionsUtils';

const AccountingPlanFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Search" source="q" alwaysOn />
  </Filter>
);
export const AccountingPlanList = (props) => (
  <List
    {...props}
    filter={isSuperUser(props.user) ? null : {
      venue: { $in: props.user.venues },
    }}
    filters={<AccountingPlanFilter />}
  >
    <Datagrid>
      <TextField source="venue" />
      <EditButton {...props} basePath="/AccountingPlans" />
      <DeleteButton {...props} basePath="/AccountingPlans" />
    </Datagrid>
  </List>
);

const AccountingPlanTitle = t(({ record, translate }) => (
  <span>{record ? translate('edit.title', { title: record.venue }) : ''}</span>
));

export const AccountingPlanEdit = t((props) => (
  <Edit title={<AccountingPlanTitle />} actions={null} {...props}>
    <SimpleForm redirect={null}>
      <TextField source="venue" />
      <AccountingSheet {...props} />
    </SimpleForm>
  </Edit>
));

export const AccountingPlanCreate = t((props) => (
  <Create {...props}>
    <SimpleForm redirect="edit">
      <ReferenceInput
        {...props}
        source="venue"
        label={props.translate('venues.name')}
        reference="venues"
        allowEmpty
      >
        <AutocompleteInput
          optionText="name"
          optionValue="name"
          options={{ fullWidth: true }}
        />
      </ReferenceInput>
    </SimpleForm>
  </Create>
));
